import { render, staticRenderFns } from "./formSubmit.vue?vue&type=template&id=4772f865&scoped=true"
import script from "./formSubmit.vue?vue&type=script&lang=js"
export * from "./formSubmit.vue?vue&type=script&lang=js"
import style0 from "./formSubmit.vue?vue&type=style&index=0&id=4772f865&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772f865",
  null
  
)

export default component.exports